import type { Resource } from '../../';
export const country_countries_SK: Resource = {"default":"Slovakia"};
